import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export const getDialogTitle = (mode: 'add' | 'edit' | 'view' | null): string => {
  switch (mode) {
    case 'add':
      return 'Dodaj novo pitanje'
    case 'edit':
      return 'Izmeni pitanje'
    case 'view':
      return 'Pregled pitanja'
    default:
      return ''
  }
}

export function getErrorMessage(error: unknown): string {
  const typed = error as { data?: { message?: string } }
  return typed?.data?.message || 'Došlo je do greške. Pokušajte ponovo kasnije.'
}
